import React from "react"

export default ({ size = 15, width/*@deprecated*/ }) => (
    <svg width={width || size} height={width || size} viewBox="0 0 15 15" className="dna-svg-icon dna-icon-path dna-icon-x">
        <path d="M.136 12.157L12.156.137l.708.706-12.02 12.02zM.136.843L.843.136 6.5 5.793l-.707.707zM7.207 7.914l.707-.707 4.95 4.95-.707.707z" />
    </svg>
)
